import { ReactNode } from 'react';

import { fixedBottomBar, fixedBottomBarSpacer } from './styles.css';

interface FixedBottomBarProps {
  children: ReactNode;
  height?: string;
}

export const FixedBottomBar = (props: FixedBottomBarProps) => {
  const { children, height } = props;

  return (
    <>
      <div
        className={fixedBottomBar}
        style={{
          minHeight: height,
        }}
      >
        {children}
      </div>
      <div
        className={fixedBottomBarSpacer}
        style={{
          height: `calc(${height ?? '76px'} + env(safe-area-inset-bottom))`,
        }}
      />
    </>
  );
};
